import { render, staticRenderFns } from "./CadastroZerodoxDocDepara.vue?vue&type=template&id=63fadc1a&"
import script from "./CadastroZerodoxDocDepara.vue?vue&type=script&lang=js&"
export * from "./CadastroZerodoxDocDepara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports